
import request from '@/utils/request' // 引入请求模块
// 通告详情
export function appraiseIndex (params) {
  return request({
    url: '/appraise/index', 
    method: 'get',
    params,
  })
}